<div class="row page-header">
    <div class="col-md-3"
        [ngStyle]="!teamMember.isActive && {'opacity':'0.4'}">
        <h4>{{teamMember.email}}<br>{{teamMember.name}}</h4>
        <p>
            Created: {{teamMember.created}}<br>
            Last mood on: {{teamMember.lastMoodDate}} via
            '{{teamMember.lastMoodChannel}}'<br>
            <small>{{teamMember.id}} <button class="btn btn-"
                    (click)="copyDBQuery(teamMember.email)"><i
                        class="fa-solid fa-copy"></i></button></small><br>
            <i class="fa-solid fa-key-skeleton"></i> Auth: {{teamMember.authProfiles}}
        </p>
        <a target="_blank" href="{{teamMember.emailProviderSearchUrl}}"><i
                class="far fa-inbox"></i> Lookup in Emailer
            ({{teamMember.emailProvider}})</a><br>
        <a target="_blank"
            href="https://my.na-01.cloud.solarwinds.com/219683007912809472/logs?q=%22app%2F%22+%22{{teamMember.email}}%22+OR+%22{{teamMember.id}}%22"><i
                class="far fa-box-archive"></i> Search in app logs</a><br>
        <a
            href="/app#/setup/account/?auth_token={{teamMember.authToken}}"
            class="btn btn-sm btn-primary"><i class="far fa-user-shield"></i>
            Take over the account</a>
    </div>
    <div class="col-md-9">
        Belongs to {{teamMember.teams.length}} teams <br>
        <table class="table table-condensed table-bordered">
            <thead>
                <tr>
                    <th scope="col">Org.</th>
                    <th scope="col">Team</th>
                    <th scope="col">User status</th>
                    <th scope="col">U.count</th>
                    <th scope="col">Subscription</th>
                    <th scope="col">orgUnit</th>
                    <th scope="col">Links</th>
                </tr>
            </thead>
            <tbody>
                @for (team of sortBy(teamMember.teams, ['name']); track team) {
                <tr [ngStyle]="!team.isActive && {'opacity':'0.4'}"
                    class="border-bottom">
                    <td>
                        <a [routerLink]="['/admin/organization', $safeNavigationMigration(team.organization?.id)]">{{team.organization?.name}}</a>
                    </td>
                    <td>{{team.name}}<br>{{team.id}}</td>
                    <td>
                        <span
                            class="d-block pt-2 text-uppercase">{{team.roles}}</span>
                        <hr>
                        <div>
                            <span
                                [ngStyle]="!team.workingDays.monday && {'opacity':'0.4'}">Mo</span>-
                            <span
                                [ngStyle]="!team.workingDays.tuesday && {'opacity':'0.4'}">Tu</span>-
                            <span
                                [ngStyle]="!team.workingDays.wednesday && {'opacity':'0.4'}">We</span>-
                            <span
                                [ngStyle]="!team.workingDays.thursday && {'opacity':'0.4'}">Th</span>-
                            <span
                                [ngStyle]="!team.workingDays.friday && {'opacity':'0.4'}">Fr</span>-
                            <span
                                [ngStyle]="!team.workingDays.saturday && {'opacity':'0.4'}">Sa</span>-
                            <span
                                [ngStyle]="!team.workingDays.sunday && {'opacity':'0.4'}">Su</span>
                            <p>{{teamMember.hour}}:{{teamMember.minute}}
                                {{teamMember.timezone}}</p>
                        </div>
                        <hr>
                        <tm-slide-toggle [ngModel]="team.activeInTeam"
                            (ngModelChange)="changeActiveInTeam(team)">
                        </tm-slide-toggle>

                    </td>
                    <td>{{team.activeUsersCount }} / {{ team.totalUsersCount}}
                        users</td>
                    <td>{{team.subscription.subscriptionType}} <span
                            [hidden]="!team.subscription.end">ends on
                            {{team.subscription.end | date :
                            "dd/MM/yyyy"}}</span>
                    </td>
                    <td>
                        <table class="table table-condensed">
                            <tbody>@for (orgUnit of team.organisationalUnits;
                                track orgUnit) {
                                <tr>
                                    <td>{{orgUnit.type}}</td>
                                    <td><a [routerLink]="['/admin/organization', orgUnit.id]">{{orgUnit.name}}</a></td>
                                </tr>
                                }
                            </tbody></table>
                    </td>
                    <td>
                        <a [routerLink]="['/admin/team', team.id]"><i
                                class="far fa-lock-alt"></i></a>
                        | <a [routerLink]="['/setup/team', team.id]"><i
                                class="far fa-cog"></i></a>
                        | <a [routerLink]="['/setup/teammembers', team.id]"><i
                                class="far fa-users"></i></a>
                        | <a [routerLink]="['/home', team.id]"><i
                                class="far fa-timeline"></i></a>
                        | <a [routerLink]="['/calendar', team.id]"><i
                                class="far fa-calendar"></i></a>
                    </td>
                </tr>
                }
            </tbody>
        </table>
        <br>

        Last events <br>
        @if (teamMember.allTeamsEvents) {
        <table
            class="table table-condensed table-bordered">
            <thead>
                <tr>
                    <td>Event name</td>
                    <td>Date</td>
                    <td>Team Id</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </thead>
            <tbody>@for (event of teamMember.allTeamsEvents; track event) {
                <tr>
                    <td>{{event.id}}</td>
                    <td>{{event.date | date : 'dd/MM/yyyy HH:mm:ss'}}</td>
                    <td>{{event.team}}</td>
                    @if (event.provider) {
                    <td>bounce provider:
                        {{event.provider}}</td>
                    }
                    @if (event.tag) {
                    <td>tag: {{event.tag}}</td>
                    }
                    @if (event.cause) {
                    <td>bounce cause: {{event.cause}}</td>
                    }
                    @if (event.isSpam) {
                    <td>bounce isSpam:
                        {{event.isSpam}}</td>
                    }
                    @if (event.educationalCardId) {
                    <td>educationalCardId:
                        {{event.educationalCardId}}</td>
                    }
                    @if (event.notificationType) {
                        <td>notificationType: {{event.notificationType}}</td>
                    }
                </tr>
                }
            </tbody>
        </table>
        }
    </div>
</div>
